import { render, staticRenderFns } from "./PanesDescription.vue?vue&type=template&id=af840276&scoped=true"
import script from "./PanesDescription.vue?vue&type=script&lang=ts"
export * from "./PanesDescription.vue?vue&type=script&lang=ts"
import style0 from "./PanesDescription.vue?vue&type=style&index=0&id=af840276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af840276",
  null
  
)

export default component.exports